export const appusers = {
  appusersSearch: 'Szukaj'
}
